<template>
    <button class="text-black text-center bg-white rounded-md flex items-center gap-4 font-bold text-4xl px-14 py-5 focus:text-black focus:bg-white hover:text-black hover:bg-white hover:border-2 hover:border-black"><slot /></button>
</template>